const POSTER_MAX_WIDTH = 256;
const SEEK_TIME = 0.1;

/** Extract a JPEG poster frame from a video blob URL. Returns a blob URL. */
export function extractPosterFrame(videoUrl: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'auto';
    video.muted = true;
    video.playsInline = true;

    const cleanup = () => {
      video.removeEventListener('seeked', onSeeked);
      video.removeEventListener('error', onError);
      video.src = '';
    };

    const onSeeked = () => {
      try {
        const scale = Math.min(1, POSTER_MAX_WIDTH / (video.videoWidth || 1));
        const w = Math.round((video.videoWidth || 256) * scale);
        const h = Math.round((video.videoHeight || 256) * scale);

        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          cleanup();
          reject(new Error('Could not create 2D context for poster'));
          return;
        }

        ctx.drawImage(video, 0, 0, w, h);
        canvas.toBlob(
          blob => {
            cleanup();
            if (blob) {
              resolve(URL.createObjectURL(blob));
            } else {
              reject(new Error('toBlob returned null'));
            }
          },
          'image/jpeg',
          0.8,
        );
      } catch (err) {
        cleanup();
        reject(err);
      }
    };

    const onError = () => {
      cleanup();
      reject(new Error('Failed to load video for poster extraction'));
    };

    video.addEventListener('seeked', onSeeked);
    video.addEventListener('error', onError);

    video.addEventListener('loadedmetadata', () => {
      video.currentTime = Math.min(SEEK_TIME, video.duration);
    }, { once: true });

    video.src = videoUrl;
  });
}